export default __webpack_public_path__ + "static/media/pending.ac416808.gif";